// Interventions créées depuis un inventaire (décisions 30, 37, 42 et 43) : formulaire allégé propre
// aux inventaires, qui produit une intervention au format du module Interventions
// (server/models/InterventionModel.js, Interventions/InterventionsApp.jsx ticketToServer).

import { objectCount, plural } from './fieldReference'

export const URGENCIES = [
	{ value: 'NORMAL', label: 'Normal' },
	{ value: 'IMPORTANT', label: 'Important' },
	{ value: 'CRITICAL', label: 'Urgent' }
]

// Même règle que l'assistant de création des interventions (InterventionsApp.jsx, SelectTypeView)
const TYPE_TEAMS = { 'Ménage': 'Équipe ménage', 'Technique': 'Équipe technique' }

// Équipes de base du module Interventions ; les autres viennent du champ `team` des utilisateurs
const BASE_TEAMS = ['Direction', 'Réception', 'Restauration']

export function defaultAssignee(type)
{
	const team = TYPE_TEAMS[type] || 'Réception'
	return { type: 'team', id: team, name: team }
}

export function teamsFromUsers(users)
{
	const names = BASE_TEAMS.concat(Object.values(TYPE_TEAMS))
	;(users || []).forEach(user => {
		const team = (user.team || '').trim()
		if (team && !names.some(name => name.toLowerCase() === team.toLowerCase()))
			names.push(team)
	})
	return names
}

export function userAssignee(user)
{
	return { type: 'employee', id: user._id, name: ((user.firstname || '') + ' ' + (user.lastname || '')).trim() }
}

// Objets manquants par rapport au modèle, quelle qu'en soit la cause (décision 30) : à la fin de
// l'inventaire, tous les thèmes sont faits, un objet non touché vaut sa référence.
export function missingObjects(themes, counts, reference)
{
	const list = []
	themes.forEach(theme => {
		theme.objects.forEach(object => {
			const count = objectCount(object, counts, reference, true)
			if (count < object.expected)
				list.push({ id: object.id, name: object.name, theme: theme.name, missing: object.expected - count })
		})
	})
	return list
}

// « À réapprovisionner : 2 Verres empilables, 1 Plateau »
export function restockDescription(objects)
{
	if (objects.length === 0)
		return ''
	return 'À réapprovisionner : ' + objects.map(object => object.missing + ' ' + object.name).join(', ')
}

export function restockAvailable(missing, restockInSeason, interventions)
{
	return restockInSeason && missing.length > 0 && !interventions.some(item => item.kind === 'restock')
}

// Raison écrite du bouton grisé « Créer l'intervention » (charte : grisé = indisponible avec raison)
export function formBlocker({ kind, type, description, checkedCount, urgency })
{
	if (kind === 'restock' && checkedCount === 0)
		return 'Cochez au moins un objet'
	if (kind !== 'restock' && !type)
		return 'Choisissez Ménage ou Technique'
	if (kind !== 'restock' && description.trim() === '')
		return kind === 'repair' ? 'Décrivez la réparation' : 'Décrivez le problème'
	if (!urgency)
		return 'Choisissez un niveau d\'urgence'
	return null
}

export function kindTitle(kind)
{
	if (kind === 'restock')
		return 'Réassort'
	if (kind === 'repair')
		return 'Réparation'
	return 'Signaler un problème'
}

// Intervention au format du serveur. auto_source : origine ; inventory_id : l'inventaire enregistré,
// renseigné à la création ; flag : « restocking » (réassort) ou « repair » (réparation, signalement).
// photo_urls : rempli à l'envoi des photos (fieldApi.createIntervention).
export function interventionFlag(kind)
{
	return kind === 'restock' ? 'restocking' : 'repair'
}

export function buildIntervention({ kind, type, description, assignee, urgency, customerPermission, pitch, stay, user, now })
{
	const author = user ? ((user.firstname || '') + ' ' + (user.lastname || '')).trim() : ''
	return {
		description: description.trim(),
		label: kindTitle(kind) + ' ' + pitch.location,
		location_id: pitch._id || null,
		type,
		status: 'TODO',
		urgency,
		is_customer_request: false,
		customer_permission: type === 'Technique' ? !!customerPermission : true,
		assigned_to: assignee,
		photo_urls: [],
		history: [{ id: 'creation-' + now, type: 'creation', user: author, timestamp: new Date(now * 1000).toISOString(), details: 'Depuis l\'inventaire de ' + pitch.location }],
		created_by: user ? user._id : null,
		stay_number: stay ? stay.stay_number : null,
		created_time: now,
		auto_source: 'inventory',
		inventory_id: null,
		flag: interventionFlag(kind)
	}
}

// Commentaires joints depuis le tour : un « memo » de l'historique chacun, comme les observations de terrain
// du module Interventions (texte dans details). comments : [{ id, text, user, time }]
export function memoEvents(comments)
{
	return (comments || []).map(comment => ({
		id: 'memo-' + comment.id,
		type: 'memo',
		user: comment.user || 'Équipe',
		timestamp: new Date(comment.time * 1000).toISOString(),
		details: comment.text
	}))
}

// « Réassort, Équipe ménage » sous le titre d'une intervention créée
export function interventionSummary(item)
{
	return [item.doc.type, item.doc.assigned_to ? item.doc.assigned_to.name : ''].filter(Boolean).join(', ')
}

export function interventionTile(interventions)
{
	if (interventions.length === 0)
		return { subtitle: 'Réassort ou réparation', done: false }
	return { subtitle: plural(interventions.length, 'intervention créée', 'interventions créées'), done: true }
}
